import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_property_key } from "@swc/helpers/_/_to_property_key";
import { ALLOWED_BILLED_UPON } from '~/types/api/drafts-search';
import { discountExpirationKind } from './serviceDiscountExpiration';
import { selectedServiceNames } from './serviceName';
const compact = (predicate)=>Object.keys(predicate).length === 0 ? undefined : predicate;
const EXISTENCE_BOUND = '0';
export const PREAPPROVED_AMOUNT_EXISTENCE = {
    gt: EXISTENCE_BOUND
};
export const isBareExistenceBound = (range)=>(range.gt == null || range.gt === EXISTENCE_BOUND) && range.gte == null && range.lt == null && range.lte == null && range.eq == null && range.neq == null;
export const isBarePreapprovedExistence = isBareExistenceBound;
export const hasSetValues = (set)=>{
    var _ref, _ref1;
    var _set_in, _set_nin;
    return set != null && (((_ref = (_set_in = set.in) === null || _set_in === void 0 ? void 0 : _set_in.length) !== null && _ref !== void 0 ? _ref : 0) > 0 || ((_ref1 = (_set_nin = set.nin) === null || _set_nin === void 0 ? void 0 : _set_nin.length) !== null && _ref1 !== void 0 ? _ref1 : 0) > 0);
};
const nonEmptySet = (set)=>hasSetValues(set) ? set : undefined;
export const setToCheckboxes = (predicate)=>{
    var _predicate_in;
    return predicate.nin != null ? {
        selected: predicate.nin,
        operator: 'exclude'
    } : {
        selected: (_predicate_in = predicate.in) !== null && _predicate_in !== void 0 ? _predicate_in : [],
        operator: 'include'
    };
};
export const checkboxesToSet = (next)=>next.operator === 'exclude' ? {
        nin: [
            ...next.selected
        ]
    } : {
        in: [
            ...next.selected
        ]
    };
export const rebuildSetField = (predicate, field, value)=>{
    const { [field]: _omit } = predicate, rest = _object_without_properties(predicate, [
        _to_property_key(field)
    ]);
    const kept = nonEmptySet(value);
    return compact(kept == null ? rest : _object_spread_props(_object_spread({}, rest), {
        [field]: kept
    }));
};
export const rebuildDecimalField = (predicate, field, value)=>{
    const { [field]: _omit } = predicate, rest = _object_without_properties(predicate, [
        _to_property_key(field)
    ]);
    return compact(value == null ? rest : _object_spread_props(_object_spread({}, rest), {
        [field]: value
    }));
};
const buildDiscount = (type, amount, expiration)=>{
    const discount = {};
    if (type != null) discount.type = type;
    if (amount != null) discount.amount = amount;
    if (expiration != null) discount.expiration = expiration;
    return Object.keys(discount).length === 0 ? undefined : discount;
};
const rebuildDiscount = (predicate, discount)=>{
    const { discount: _omit } = predicate, rest = _object_without_properties(predicate, [
        "discount"
    ]);
    return compact(discount == null ? rest : _object_spread_props(_object_spread({}, rest), {
        discount
    }));
};
export const rebuildDiscountType = (predicate, value)=>{
    var _predicate_discount, _predicate_discount1;
    return rebuildDiscount(predicate, buildDiscount(nonEmptySet(value), (_predicate_discount = predicate.discount) === null || _predicate_discount === void 0 ? void 0 : _predicate_discount.amount, (_predicate_discount1 = predicate.discount) === null || _predicate_discount1 === void 0 ? void 0 : _predicate_discount1.expiration));
};
export const rebuildDiscountAmount = (predicate, value)=>{
    var _predicate_discount, _predicate_discount1;
    return rebuildDiscount(predicate, buildDiscount((_predicate_discount = predicate.discount) === null || _predicate_discount === void 0 ? void 0 : _predicate_discount.type, value, (_predicate_discount1 = predicate.discount) === null || _predicate_discount1 === void 0 ? void 0 : _predicate_discount1.expiration));
};
export const removeDiscountExpiration = (predicate)=>{
    var _predicate_discount, _predicate_discount1;
    return rebuildDiscount(predicate, buildDiscount((_predicate_discount = predicate.discount) === null || _predicate_discount === void 0 ? void 0 : _predicate_discount.type, (_predicate_discount1 = predicate.discount) === null || _predicate_discount1 === void 0 ? void 0 : _predicate_discount1.amount, undefined));
};
const buildPriceIncrease = (exists, percent, startOnType)=>{
    const priceIncrease = {};
    if (exists != null) priceIncrease.exists = exists;
    if (percent != null) priceIncrease.percent = percent;
    if (startOnType != null) priceIncrease.startOnType = startOnType;
    return Object.keys(priceIncrease).length === 0 ? undefined : priceIncrease;
};
const rebuildPriceIncrease = (predicate, priceIncrease)=>{
    const { priceIncrease: _omit } = predicate, rest = _object_without_properties(predicate, [
        "priceIncrease"
    ]);
    return compact(priceIncrease == null ? rest : _object_spread_props(_object_spread({}, rest), {
        priceIncrease
    }));
};
export const rebuildPriceIncreasePercent = (predicate, value)=>{
    var _predicate_priceIncrease, _predicate_priceIncrease1;
    return rebuildPriceIncrease(predicate, buildPriceIncrease((_predicate_priceIncrease = predicate.priceIncrease) === null || _predicate_priceIncrease === void 0 ? void 0 : _predicate_priceIncrease.exists, value, (_predicate_priceIncrease1 = predicate.priceIncrease) === null || _predicate_priceIncrease1 === void 0 ? void 0 : _predicate_priceIncrease1.startOnType));
};
export const rebuildPriceIncreaseStartOnType = (predicate, value)=>{
    var _predicate_priceIncrease, _predicate_priceIncrease1;
    return rebuildPriceIncrease(predicate, buildPriceIncrease((_predicate_priceIncrease = predicate.priceIncrease) === null || _predicate_priceIncrease === void 0 ? void 0 : _predicate_priceIncrease.exists, (_predicate_priceIncrease1 = predicate.priceIncrease) === null || _predicate_priceIncrease1 === void 0 ? void 0 : _predicate_priceIncrease1.percent, nonEmptySet(value)));
};
export const rebuildPriceIncreaseExists = (predicate, value)=>{
    var _predicate_priceIncrease, _predicate_priceIncrease1;
    return rebuildPriceIncrease(predicate, value === false ? buildPriceIncrease(false, undefined, undefined) : buildPriceIncrease(value, (_predicate_priceIncrease = predicate.priceIncrease) === null || _predicate_priceIncrease === void 0 ? void 0 : _predicate_priceIncrease.percent, (_predicate_priceIncrease1 = predicate.priceIncrease) === null || _predicate_priceIncrease1 === void 0 ? void 0 : _predicate_priceIncrease1.startOnType));
};
export const rebuildLimitedTimeDiscount = (predicate, value)=>{
    const { limitedTimeDiscountOffer: _omit } = predicate, rest = _object_without_properties(predicate, [
        "limitedTimeDiscountOffer"
    ]);
    return compact(value == null ? rest : _object_spread_props(_object_spread({}, rest), {
        limitedTimeDiscountOffer: {
            exists: value
        }
    }));
};
const buildMaxCharges = (exists, limit)=>{
    const maxCharges = {};
    if (exists != null) maxCharges.exists = exists;
    if (limit != null) maxCharges.limit = limit;
    return Object.keys(maxCharges).length === 0 ? undefined : maxCharges;
};
const rebuildMaxCharges = (predicate, maxCharges)=>{
    const { maxCharges: _omit } = predicate, rest = _object_without_properties(predicate, [
        "maxCharges"
    ]);
    return compact(maxCharges == null ? rest : _object_spread_props(_object_spread({}, rest), {
        maxCharges
    }));
};
export const rebuildMaxChargesExists = (predicate, value)=>{
    var _predicate_maxCharges;
    return rebuildMaxCharges(predicate, value === false ? buildMaxCharges(false, undefined) : buildMaxCharges(value, (_predicate_maxCharges = predicate.maxCharges) === null || _predicate_maxCharges === void 0 ? void 0 : _predicate_maxCharges.limit));
};
export const rebuildMaxChargesLimit = (predicate, value)=>{
    var _predicate_maxCharges;
    return rebuildMaxCharges(predicate, buildMaxCharges((_predicate_maxCharges = predicate.maxCharges) === null || _predicate_maxCharges === void 0 ? void 0 : _predicate_maxCharges.exists, value));
};
export const rebuildBillUpfront = (predicate, value)=>{
    const { billUpfront: _omit } = predicate, rest = _object_without_properties(predicate, [
        "billUpfront"
    ]);
    return compact(value == null ? rest : _object_spread_props(_object_spread({}, rest), {
        billUpfront: value
    }));
};
export const rebuildDescription = (predicate, value)=>{
    const { description: _omit } = predicate, rest = _object_without_properties(predicate, [
        "description"
    ]);
    return compact(value == null ? rest : _object_spread_props(_object_spread({}, rest), {
        description: {
            exists: value
        }
    }));
};
const isNameOnlyArm = (arm)=>Object.keys(arm).length === 1 && arm.name != null;
const hasDiscountContent = (discount)=>discount != null && (hasSetValues(discount.type) || discount.amount != null || discountExpirationKind(discount.expiration) != null);
const hasFlattenableContent = (predicate)=>{
    var _predicate_priceIncrease, _predicate_priceIncrease1, _predicate_priceIncrease2, _predicate_limitedTimeDiscountOffer, _predicate_maxCharges, _predicate_maxCharges1, _predicate_description;
    return selectedServiceNames(predicate).length > 0 || hasSetValues(predicate.recurrence) || hasSetValues(predicate.billedUpon) || hasSetValues(predicate.pricingType) || predicate.priceMin != null || predicate.priceMax != null || predicate.cap != null || hasDiscountContent(predicate.discount) || ((_predicate_priceIncrease = predicate.priceIncrease) === null || _predicate_priceIncrease === void 0 ? void 0 : _predicate_priceIncrease.percent) != null || ((_predicate_priceIncrease1 = predicate.priceIncrease) === null || _predicate_priceIncrease1 === void 0 ? void 0 : _predicate_priceIncrease1.exists) != null || hasSetValues((_predicate_priceIncrease2 = predicate.priceIncrease) === null || _predicate_priceIncrease2 === void 0 ? void 0 : _predicate_priceIncrease2.startOnType) || ((_predicate_limitedTimeDiscountOffer = predicate.limitedTimeDiscountOffer) === null || _predicate_limitedTimeDiscountOffer === void 0 ? void 0 : _predicate_limitedTimeDiscountOffer.exists) != null || ((_predicate_maxCharges = predicate.maxCharges) === null || _predicate_maxCharges === void 0 ? void 0 : _predicate_maxCharges.exists) != null || ((_predicate_maxCharges1 = predicate.maxCharges) === null || _predicate_maxCharges1 === void 0 ? void 0 : _predicate_maxCharges1.limit) != null || predicate.billUpfront != null || ((_predicate_description = predicate.description) === null || _predicate_description === void 0 ? void 0 : _predicate_description.exists) != null;
};
const MAPPED_BILLED_UPON = new Set(ALLOWED_BILLED_UPON);
const hasUnmappedBilledUpon = (set)=>{
    var _ref;
    return ((_ref = set === null || set === void 0 ? void 0 : set.in) !== null && _ref !== void 0 ? _ref : []).some((value)=>!MAPPED_BILLED_UPON.has(value));
};
const hasUnmappedDiscountExpiration = (expiration)=>hasSetValues(expiration === null || expiration === void 0 ? void 0 : expiration.type) && discountExpirationKind(expiration) == null;
export const isFlattenableCondition = (predicate, quantifier)=>{
    var _ref, _predicate_or;
    var _predicate_billedUpon_nin, _predicate_billedUpon, _predicate_discount;
    if (quantifier !== 'any') return false;
    if (predicate.not != null) return false;
    if (((_ref = (_predicate_billedUpon = predicate.billedUpon) === null || _predicate_billedUpon === void 0 ? void 0 : (_predicate_billedUpon_nin = _predicate_billedUpon.nin) === null || _predicate_billedUpon_nin === void 0 ? void 0 : _predicate_billedUpon_nin.length) !== null && _ref !== void 0 ? _ref : 0) > 0) return false;
    if (hasUnmappedBilledUpon(predicate.billedUpon)) return false;
    if (hasUnmappedDiscountExpiration((_predicate_discount = predicate.discount) === null || _predicate_discount === void 0 ? void 0 : _predicate_discount.expiration)) return false;
    const orArms = (_predicate_or = predicate.or) !== null && _predicate_or !== void 0 ? _predicate_or : [];
    if (orArms.some((arm)=>!isNameOnlyArm(arm))) return false;
    if (predicate.name != null && orArms.some((arm)=>arm.name != null)) return false;
    return hasFlattenableContent(predicate);
};
